module.exports = __webpack_public_path__ + "img/empty-wallet.d9941bb4.png";